import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-hero">
        <div className="privacy-hero-content">
          <h1>Terms of Service & Privacy Policy</h1>
          <p>Effective Date: July 29, 2025</p>
        </div>
      </div>

      <div className="privacy-content">
        <div className="privacy-card">
          <h2>TERMS OF SERVICE</h2>
          <p><strong>Effective Date: July 29, 2025</strong></p>
          
          <h3>INTRODUCTION</h3>
          <p>By using tacomasjunkremoval.com and related services you agree to these Terms of Service and the Privacy Policy. If you do not agree, do not use the site.</p>
          
          <h3>SITE OPERATOR</h3>
          <p>The site is operated by connectrader on behalf of Tacoma's Junk Removal.</p>
          
          <h3>ELIGIBILITY AND ACCOUNT</h3>
          <p>You must be at least 18 years old or of legal age where you live.</p>
          <p>You are responsible for any activity under your account credentials.</p>
          
          <h3>USER CONDUCT</h3>
          <p>You agree not to:</p>
          <ul>
            <li>Violate any laws or regulations</li>
            <li>Reverse engineer or disrupt site functionality</li>
            <li>Copy or share content without authorization</li>
            <li>Interfere with other users or degrade service</li>
          </ul>
          <p>Violations can result in suspension or termination of access.</p>
          
          <h3>SERVICES AND SCHEDULING</h3>
          <p>Tacoma's Junk Removal removes nonhazardous items only. Scheduling, quotes, payments, and cancellations are managed through the site.</p>
          
          <h3>PAYMENT AND FEES</h3>
          <p>Payment is due upon completion unless otherwise arranged.</p>
          <p>Extra charges may apply for difficult access, special items, or delays.</p>
          <p>Late payments may incur fees as permitted by law.</p>
          
          <h3>LIABILITY AND WARRANTY</h3>
          <p>Services are provided "as is." Neither connectrader nor Tacoma's Junk Removal guarantee uninterrupted or error-free service.</p>
          <p>They are not liable for indirect or consequential damages.</p>
          
          <h3>INDEMNIFICATION</h3>
          <p>You agree to hold connectrader and Tacoma's Junk Removal harmless from claims arising from your violation of these Terms.</p>
          
          <h3>MODIFICATIONS</h3>
          <p>Terms may be updated at any time. Continued use after changes means you accept the new Terms.</p>
          
          <h3>GOVERNING LAW</h3>
          <p>These Terms are governed by Washington State law. Disputes will be resolved in Pierce County, WA courts.</p>
          
          <h3>CONTACT</h3>
          <p>For questions or notices, email support@connectrader.com</p>
        </div>

        <div className="privacy-card">
          <h2>PRIVACY POLICY</h2>
          <p><strong>Effective Date: July 29, 2025</strong></p>
          
          <h3>INTRODUCTION</h3>
          <p>Tacoma's Junk Removal and connectrader respect your privacy. This policy explains what data we collect, how we use it, and your rights.</p>
          
          <h3>INFORMATION WE COLLECT</h3>
          <p>We collect:</p>
          <ul>
            <li>Personal data: name, address, email, phone, payment info</li>
            <li>Technical data: IP address, browser type, device data</li>
          </ul>
          
          <h3>HOW WE USE YOUR DATA</h3>
          <p>We use personal data to:</p>
          <ul>
            <li>Provide and fulfill services</li>
            <li>Communicate scheduling or updates</li>
            <li>Detect fraud and secure services</li>
            <li>Send marketing messages if you opted in (you may opt out)</li>
          </ul>
          
          <h3>DATA SHARING</h3>
          <p>We do not sell your personal information. We may share data with:</p>
          <ul>
            <li>Third-party service providers under confidentiality agreements</li>
            <li>Law enforcement or as required by law</li>
          </ul>
          
          <h3>COOKIES AND TRACKING</h3>
          <p>We use cookies and web beacons to remember preferences and analyze usage.</p>
          <p>You can disable cookies in your browser, but this may affect site functionality.</p>
          
          <h3>DATA RETENTION</h3>
          <p>We retain personal data only as long as needed to provide services or comply with legal obligations. When no longer needed, data is deleted or anonymized.</p>
          
          <h3>SECURITY</h3>
          <p>We implement reasonable safeguards to protect your data, though no system is completely secure.</p>
          
          <h3>CHILDREN'S PRIVACY</h3>
          <p>We do not knowingly collect data from anyone under 13. If such data is discovered, it is deleted unless parental consent is verified.</p>
          
          <h3>CHANGES TO THIS POLICY</h3>
          <p>This policy may be updated at any time. Continued use after changes means you accept the updated version.</p>
          
          <h3>YOUR RIGHTS</h3>
          <p>Depending on your location, you may request access, correction, or deletion of your personal data. Contact support@connectrader.com</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;